import CityPage from "../CityPage";

export default function HomerGlen() {
  return <CityPage slug="homer-glen" />;
}
